import clsx from 'clsx'
import GridSpinner from 'components/UI/GridSpinner'
import { Alert, Col, Grid, Row, Typography } from 'gu-ui-kit'
import CreateAgencyForm from 'modules/Forms/Agency/Create'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import formatPhone from 'utils/formatPhone'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Agency/AgencyCard/agency-card.module.scss'

const AgencyCard = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(['agency', 'common'])
  const { loading, loadFailed, id, name, email, phone } = useSelector(({ agency }) => agency)
  const { sm: isMobile } = useBreakpoint()

  useEffect(() => {
    dispatch({ type: 'AGENCY/LOAD_DATA' })
  }, [])

  if (loading) {
    return <GridSpinner />
  }

  if (loadFailed) {
    return (
      <Alert variant="filled" severity="error">
        {t('common::server_request_error')}
      </Alert>
    )
  }

  return !loading && !id ? (
    <CreateAgencyForm />
  ) : (
    <>
      <Grid>
        <Row alignItems="center" className={styles['head']}>
          <Col
            s="auto"
            sm="auto"
            xs="auto"
            className={clsx(styles['agency-avatar'], 'bg-network-admitad')}
          >
            <span className={styles['agency-abbreviation']}>Ad</span>
          </Col>
          <Col s="6" sm="auto" xs="auto">
            {!isMobile && <span className={styles.headerUpstring}>{t('my_agency.title')}</span>}
            <Typography variant={'Subtitle-100'} component={'p'} noMargin>
              {name}
            </Typography>
          </Col>
        </Row>
      </Grid>
      <div className={styles['agency-card']}>
        <div className={styles['card-row']}>
          <label>{t('my_agency.email_label')}:</label>
          {email || '—'}
        </div>

        <div className={styles['card-row']}>
          <label>{t('my_agency.phone_label')}:</label>
          {formatPhone(phone) || '—'}
        </div>
      </div>
    </>
  )
}

export default AgencyCard
